export const GET_POLICIES_SUMMARY = 'GET_POLICIES_SUMMARY';
export const GET_POLICIES_SUMMARY_SUCCESS = 'GET_POLICIES_SUMMARY_SUCCESS';
export const GET_POLICIES_SUMMARY_FAILURE = 'GET_POLICIES_SUMMARY_FAILURE';
